import { Injectable } from '@angular/core';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ExamCollector } from '../models/exam-collectors';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JwtAuthService } from '../../shared/services/auth/jwt-auth.service';
import { FeatureFlagService } from '../../shared/services/feature-flag.service';

@Injectable({
  providedIn: 'root',
})
export class ExamCollectorsEntityService extends BaseEntityService<ExamCollector> {

  constructor(
    private featureFlagService: FeatureFlagService,
    private jwtAuthService: JwtAuthService,
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'examCollector', plural: 'examCollectors', url: 'exam-collectors' },
      routerParamsService
    );
    this.nameId = 'examCollectorId';
  }


  configure(body: ExamCollector): Observable<any> {
    return this.httpClient.post(`${ this.entityUrl }/configure`, { examCollector: body }).pipe(
      map(res => res['examCollector']),
    );
  }

  getAllExamColletorsAvailable(): Observable<ExamCollector[]> {
    return this.getWithQuery({
      personIds: this.jwtAuthService.getUser().id,
    })
      .pipe(
        map(examCollectors => {

          // examCollectors = RESPONSE_MOCK.examCollectors as any;

          return examCollectors.filter(collector => {
            return collector.status !== 'UNAVAILABLE' && this.checkExamCollectorFeatureFlag(collector);
          });
        }),
      );
  }

  getAllExamColletorsAvailableAndOrder(): Observable<ExamCollector[]> {
    return this.getAllExamColletorsAvailable()
      .pipe(
        map(examCollectors => {
          return examCollectors.sort(collector => {
            return collector.status === 'ACTIVE' ? 1 : 0;
          });
        }),
      );
  }

  checkExamCollectorFeatureFlag(examCollector: ExamCollector) {
    if (examCollector.integrationName === 'OUT_DASA_NAV_PRO') {
      return this.featureFlagService.hasFlagEnable(['APP_EXAM_COLLECTOR_OUT_DASA_NAV_PRO']);
    }

    if (examCollector.integrationName === 'OUT_GRUPO_FLEURY') {
      return this.featureFlagService.hasFlagEnable(['APP_EXAM_COLLECTOR_OUT_GRUPO_FLEURY']);
    }

    if (examCollector.integrationName === 'OUT_GRUPO_PARDINI') {
      return this.featureFlagService.hasFlagEnable(['APP_EXAM_COLLECTOR_OUT_GRUPO_PARDINI']);
    }
  }

  fetchResults(body: ExamCollector): Observable<any> {
    return this.httpClient.post(`${ this.entityUrl }/fetch-results`, { examCollector: body });
  }
}


const RESPONSE_MOCK = {
  'examCollectors': [
    {
      'id': 14597,
      'integrationName': 'OUT_GRUPO_PARDINI',
      'status': 'ACTIVE',
      'additionalData': {
        'status': 'ACTIVE',
        'lastSync': '2026-02-05T18:13:18.870513Z',
        'lastSendLink': '2026-02-05T18:12:35.505314Z',
        'lastFetchResults': '2026-02-13T10:48:22.567677Z',
        'failedProtocolsFap': [],
        'emails': [
          {
            'id': 3,
            'commentedValue': 'heit*********@hotmail.com'
          }
        ],
        'phones': [
          {
            'id': 5,
            'commentedValue': '11*******52'
          }
        ]
      },
      'person': {
        'id': 5492,
        'createdAt': '2024-02-07T19:42:03.272258Z',
        'updatedAt': '2024-02-19T18:15:26.585351Z',
        'document': '85787310268',
        'phone': '+5511985024625',
        'phoneStatus': 'VERIFIED',
        'phoneEnding': '25',
        'email': 'joel@marsaude.net',
        'personProperties': {
          'id': 5488,
          'createdAt': '2024-02-07T19:42:03.301096Z',
          'updatedAt': '2024-02-07T19:42:03.301099Z',
          'name': 'Felipe Joel Costa da Silva Lima',
          'biologicalSex': 'MALE',
          'birthdate': '1989-02-04'
        }
      }
    },
    {
      'id': 10625,
      'integrationName': 'OUT_GRUPO_FLEURY',
      'status': 'AVAILABLE',
      'additionalData': {
        'status': 'ACTIVE',
        'lastSync': '2026-02-05T18:13:18.870513Z',
        'lastSendLink': '2026-02-05T18:12:35.505314Z',
        'lastFetchResults': '2026-02-13T10:48:22.567677Z',
        'failedProtocolsFap': [],
        'emails': [
          {
            'id': 3,
            'commentedValue': 'heit*********@hotmail.com'
          }
        ],
        'phones': [
          {
            'id': 5,
            'commentedValue': '11*******52'
          }
        ]
      },
      'person': {
        'id': 5492,
        'createdAt': '2024-02-07T19:42:03.272258Z',
        'updatedAt': '2024-02-19T18:15:26.585351Z',
        'document': '85787310268',
        'phone': '+5511985024625',
        'phoneStatus': 'VERIFIED',
        'phoneEnding': '25',
        'email': 'joel@marsaude.net',
        'personProperties': {
          'id': 5488,
          'createdAt': '2024-02-07T19:42:03.301096Z',
          'updatedAt': '2024-02-07T19:42:03.301099Z',
          'name': 'Felipe Joel Costa da Silva Lima',
          'biologicalSex': 'MALE',
          'birthdate': '1989-02-04'
        }
      }
    },
    {
      'id': 7205,
      'integrationName': 'OUT_DASA_NAV_PRO',
      'status': 'AVAILABLE',
      'additionalData': {
        'status': 'AVAILABLE',
        'lastSync': '2026-02-05T18:13:18.870513Z',
        'lastSendLink': '2026-02-05T18:12:35.505314Z',
        'lastFetchResults': '2026-02-13T10:48:22.567677Z',
        'failedProtocolsFap': [],
        'commentedEmail': 'lfj***@gmail.com',
        'commentedPhone': '(11) xxxxx-4625'
      },
      'person': {
        'id': 5492,
        'createdAt': '2024-02-07T19:42:03.272258Z',
        'updatedAt': '2024-02-19T18:15:26.585351Z',
        'document': '85787310268',
        'phone': '+5511985024625',
        'phoneStatus': 'VERIFIED',
        'phoneEnding': '25',
        'email': 'joel@marsaude.net',
        'personProperties': {
          'id': 5488,
          'createdAt': '2024-02-07T19:42:03.301096Z',
          'updatedAt': '2024-02-07T19:42:03.301099Z',
          'name': 'Felipe Joel Costa da Silva Lima',
          'biologicalSex': 'MALE',
          'birthdate': '1989-02-04'
        }
      }
    }
  ]
};
